export const LOCATION_SEARCH_ENDPOINT = '/svcs/ac/index/'
export const HTL_LOCATION_SEARCH_ENDPOINT_SUFFIX = '/6/3/3/3'
export const RC_LOCATION_SEARCH_ENDPOINT = '/pws/v0/index/drive/search/'

export const RC_LOCATION_SEARCH_ENDPOINT_QS =
  '?numCities=6&numAirports=5&numPOIs=3'

export const EMAIL_SIGN_UP_ENDPOINT = '/landing/email_signup.do'
export const RECENT_SEARCH_ENDPOINT = '/svcs/eng/gblsvcs/v1/clair'
export const TEXT_MOBILE_APP_ENDPOINT = '/svcs/eng/gblsvcs/v1/sms/send'
export const UPCOMING_TRIPS_ENDPOINT = '/pws/v0/customer/offer'
export const HTL_GEO_LOCATION_SEARCH_ENDPOINT =
  '/svcs/ac/index/hotels/rtlsearch/geo/'
export const STAY_INTEGRATED_LISTING_ENDPOINT =
  '/pws/v0/stay/integratedlisting/'
export const PACKAGE_PRICE_CACHE_ENDPOINT = '/pws/v0/psapi/search/pricecache'
export const OFFER_LIST_P3_ENDPOINT = `/pws/v0/p3svcs/offers`
